import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import { Provider as ReduxProvider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import { ThemeProvider } from '@material-ui/styles';
import * as serviceWorker from './serviceWorker';
import { Store } from './redux/store';
import { instajobTheme } from './shared/helpers/instajobTheme';
import SuccessSnackbar from './shared/components/snackbars/SuccessSnackbar';
import WarningSnackbar from './shared/components/snackbars/WarningSnackbar';
import DangerSnackbar from './shared/components/snackbars/DangerSnackbar';
import DefaultSnackbar from './shared/components/snackbars/DefaultSnackbar';

const MainApp = () => {
    return (
        <ThemeProvider theme={instajobTheme}>
            <ReduxProvider store={Store}>
                <BrowserRouter>
                    <App />
                    <SuccessSnackbar />
                    <WarningSnackbar />
                    <DangerSnackbar />
                    <DefaultSnackbar />
                </BrowserRouter>
            </ReduxProvider>
        </ThemeProvider>
    );
};

ReactDOM.render(<MainApp />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
